import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_PATIENT_DETAIL_API_URL } from '@custom/constant';

const patientDetails = createAsyncThunk('patient', async ({ uhid }: { uhid: string }) => {
    try {
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');

      if (!hospitalId) {
        throw new Error('Hospital ID not found in session storage');
      }

      let url = `${GET_PATIENT_DETAIL_API_URL}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          hospitalId: hospitalId,
          uhid: uhid,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch patient details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default patientDetails;
